export const setExpiringLocalStorage = (key, value, expiryMilliSeconds) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + expiryMilliSeconds,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getExpiringLocalStorage = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};
